export default __webpack_public_path__ + "static/media/authenticationGuidPic.08ec15b3.png";